"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SimpleMessage({ width, height, message, }) {
    return (react_1.default.createElement("div", { style: {
            width: width + "px",
            height: height + "px",
            background: "#E8E8E8",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "3px solid",
            color: "#666666",
            borderRadius: "10px",
        } },
        react_1.default.createElement("div", { style: {
                fontSize: height / 12 + "px",
                padding: "2%",
            } }, message)));
}
exports.default = SimpleMessage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2ltcGxlTWVzc2FnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL290aGVyL1NpbXBsZU1lc3NhZ2UudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQ0Esa0RBQTBCO0FBRTFCLFNBQXdCLGFBQWEsQ0FBQyxFQUNwQyxLQUFLLEVBQ0wsTUFBTSxFQUNOLE9BQU8sR0FDd0I7SUFDL0IsT0FBTyxDQUNMLHVDQUNFLEtBQUssRUFBRTtZQUNMLEtBQUssRUFBRSxLQUFLLEdBQUcsSUFBSTtZQUNuQixNQUFNLEVBQUUsTUFBTSxHQUFHLElBQUk7WUFDckIsVUFBVSxFQUFFLFNBQVM7WUFDckIsT0FBTyxFQUFFLE1BQU07WUFDZixVQUFVLEVBQUUsUUFBUTtZQUNwQixjQUFjLEVBQUUsUUFBUTtZQUN4QixNQUFNLEVBQUUsV0FBVztZQUNuQixLQUFLLEVBQUUsU0FBUztZQUNoQixZQUFZLEVBQUUsTUFBTTtTQUNyQjtRQUVELHVDQUNFLEtBQUssRUFBRTtnQkFDTCxRQUFRLEVBQUUsTUFBTSxHQUFHLEVBQUUsR0FBRyxJQUFJO2dCQUM1QixPQUFPLEVBQUUsSUFBSTthQUNkLElBRUEsT0FBTyxDQUNKLENBQ0YsQ0FDUCxDQUFDO0FBQ0osQ0FBQztBQTdCRCxnQ0E2QkMifQ==